module.exports = __webpack_public_path__ + "img/1-quad.b5f95ec4.png";